<template>
  <div>
    <headline :content="$t('asset.title')">
      <v-btn color="info" @click="showAsset(true, false)">{{ $t('asset.add_asset_list') }}</v-btn>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <asset-list
          :search="search"
          :loading="isLoading"
          @onRemove="onPreRemove"
          @onUpdate="onUpdate"
        ></asset-list>
      </template>
    </layout>
    <asset-form
      v-if="asset && asset.object"
      v-model="isAsset"
      :isCreate="asset.isCreate"
      :isUpdate="asset.isUpdate"
      :object="asset.object"
      @onSave="getAssets"
    ></asset-form>
    <confirm-dialog-component @onOk="onRemove" v-model="isConfirm" :type="`error`"></confirm-dialog-component>
  </div>
</template>

<script>
import AssetForm from "../../components/AssetForm.vue";
import AssetList from "../../components/AssetList.vue";
import ConfirmDialogComponent from "../../components/ConfirmDialog.component.vue";
import Headline from "../../components/Headline.vue";
import Layout from "../../components/Layout.vue";
export default {
  components: {
    Layout,
    Headline,
    AssetForm,
    AssetList,
    ConfirmDialogComponent
  },
  data() {
    return {
      isAsset: false,
      asset: {
        isCreate: false,
        isUpdate: false,
        object: {}
      },
      search: "",
      isLoading: false,
      preRemoveId: "",
      isConfirm: false
    };
  },
  created() {
    this.onInit();
  },
  methods: {
    async onInit() {
      await this.getAssets();
    },
    showAsset(isCreate, isUpdate, object = {}) {
      this.isAsset = true;
      this.asset = {
        isCreate: isCreate,
        isUpdate: isUpdate,
        object: object
      };
    },
    async getAssets() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("asset/getAssets", {
          projectId: this.$route.params.projectId
        });
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$toast.show({
          content: this.$t('validate.error_invalid_send_data'),
          color: "error"
        });
      }
    },
    onPreRemove(item) {
      this.preRemoveId = item.id;
      this.isConfirm = true;
    },
    async onRemove() {
      try {
        const response = await this.$store.dispatch("asset/removeAsset", {
          id: this.preRemoveId
        });
        this.onInit();
      } catch (error) {
        console.log(error);
      }
    },
    onUpdate(data) {
      this.showAsset(false, true, data);
    }
  }
};
</script>

<style>
</style>